import { FC, memo } from 'react';
import Title from 'antd/lib/typography/Title';
import { Typography } from 'antd';
import { SipAccountsIcon } from '../SideMenu/icons';
import styles from './style.module.css';

interface Props {
  title: string;
  subtitle?: string;
  svg?: boolean;
  svgType?: string;
}

const SiteMenu: FC<Props> = ({ title, subtitle, svg, svgType }: Props) => {
  return (
    <div className={styles.SiteMenu}>
      {svg && svgType === 'incomingCalls' && (
        <svg
          className={styles.svg}
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="50" height="50" rx="11" fill="#155DFC" />
          <g clipPath="url(#clip0_115_1115)">
            <path
              d="M30.3334 11.6667V19.6667M30.3334 19.6667H38.3334M30.3334 19.6667L39.6667 10.3334M38.3334 31.56V35.56C38.3349 35.9314 38.2589 36.2989 38.1101 36.6392C37.9613 36.9794 37.7431 37.2848 37.4695 37.5359C37.1959 37.7869 36.8728 37.978 36.5211 38.097C36.1693 38.2159 35.7966 38.2601 35.4267 38.2267C31.3239 37.7809 27.3827 36.3789 23.9201 34.1334C20.6985 32.0863 17.9672 29.3549 15.9201 26.1334C13.6667 22.655 12.2644 18.6947 11.8267 14.5734C11.7934 14.2047 11.8372 13.8331 11.9554 13.4822C12.0736 13.1314 12.2635 12.809 12.5131 12.5355C12.7627 12.2621 13.0665 12.0437 13.4051 11.8941C13.7438 11.7445 14.1099 11.6671 14.4801 11.6667H18.4801C19.1271 11.6603 19.7545 11.8895 20.2451 12.3114C20.7357 12.7334 21.0562 13.3193 21.1467 13.96C21.3156 15.2401 21.6287 16.497 22.0801 17.7067C22.2595 18.1839 22.2983 18.7026 22.1919 19.2012C22.0856 19.6998 21.8386 20.1575 21.4801 20.52L19.7867 22.2134C21.6848 25.5514 24.4487 28.3153 27.7867 30.2134L29.4801 28.52C29.8426 28.1616 30.3003 27.9145 30.7989 27.8082C31.2975 27.7018 31.8162 27.7407 32.2934 27.92C33.5031 28.3714 34.76 28.6845 36.0401 28.8534C36.6878 28.9447 37.2793 29.271 37.7021 29.77C38.125 30.2691 38.3496 30.9061 38.3334 31.56Z"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_115_1115">
              <rect
                width="32"
                height="32"
                fill="white"
                transform="translate(9 9)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
      {svg && svgType === 'outgoingCalls' && (
        <svg
          className={styles.svg}
          xmlns="http://www.w3.org/2000/svg"
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
        >
          <rect width="50" height="50" rx="11" fill="#155DFC" />
          <g clipPath="url(#clip0_69_431)">
            <path
              d="M34.3333 10.3333L39.6666 15.6667M39.6666 15.6667L34.3333 21M39.6666 15.6667H29M38.3333 31.56V35.56C38.3348 35.9313 38.2587 36.2989 38.11 36.6391C37.9612 36.9794 37.743 37.2848 37.4694 37.5358C37.1958 37.7869 36.8727 37.978 36.521 38.0969C36.1692 38.2159 35.7964 38.2601 35.4266 38.2267C31.3237 37.7809 27.3826 36.3789 23.92 34.1333C20.6984 32.0862 17.9671 29.3549 15.92 26.1333C13.6666 22.6549 12.2643 18.6947 11.8266 14.5733C11.7933 14.2046 11.8371 13.833 11.9553 13.4822C12.0735 13.1313 12.2634 12.8089 12.513 12.5355C12.7626 12.2621 13.0664 12.0436 13.405 11.894C13.7437 11.7444 14.1097 11.667 14.48 11.6667H18.48C19.127 11.6603 19.7543 11.8894 20.245 12.3114C20.7356 12.7333 21.0561 13.3193 21.1466 13.96C21.3154 15.2401 21.6286 16.497 22.08 17.7067C22.2593 18.1839 22.2982 18.7025 22.1918 19.2012C22.0855 19.6998 21.8384 20.1575 21.48 20.52L19.7866 22.2133C21.6847 25.5514 24.4486 28.3153 27.7866 30.2133L29.48 28.52C29.8425 28.1615 30.3002 27.9145 30.7988 27.8081C31.2974 27.7018 31.8161 27.7406 32.2933 27.92C33.503 28.3714 34.7599 28.6845 36.04 28.8533C36.6876 28.9447 37.2792 29.2709 37.702 29.77C38.1248 30.269 38.3495 30.9061 38.3333 31.56Z"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_69_431">
              <rect
                width="32"
                height="32"
                fill="white"
                transform="translate(9 9)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
      {svg && svgType === 'incomingStats' && (
        <svg
          className={styles.svg}
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="50" height="50" rx="11" fill="#155DFC" />
          <g clipPath="url(#clip0_225_1675)">
            <path
              d="M40.6666 22L28 34.6667L21.3333 28L11.3333 38M40.6666 22H32.6666M40.6666 22V30"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g clipPath="url(#clip1_225_1675)">
            <path
              d="M21 8.25V12M21 12H24.75M21 12L25.375 7.625M24.75 17.575V19.45C24.7507 19.6241 24.7151 19.7964 24.6453 19.9558C24.5756 20.1153 24.4733 20.2585 24.3451 20.3762C24.2168 20.4938 24.0654 20.5834 23.9005 20.6392C23.7356 20.695 23.5609 20.7157 23.3875 20.7C21.4643 20.491 19.6169 19.8338 17.9938 18.7812C16.4837 17.8217 15.2034 16.5414 14.2438 15.0312C13.1875 13.4008 12.5302 11.5444 12.325 9.6125C12.3094 9.43967 12.3299 9.26548 12.3853 9.10102C12.4407 8.93656 12.5298 8.78543 12.6467 8.65726C12.7637 8.5291 12.9061 8.42669 13.0649 8.35658C13.2236 8.28646 13.3952 8.25016 13.5688 8.25H15.4438C15.7471 8.24701 16.0411 8.35442 16.2711 8.55221C16.5011 8.74999 16.6513 9.02465 16.6938 9.325C16.7729 9.92504 16.9197 10.5142 17.1313 11.0813C17.2154 11.305 17.2336 11.5481 17.1837 11.7818C17.1339 12.0155 17.0181 12.2301 16.85 12.4L16.0563 13.1937C16.946 14.7585 18.2416 16.054 19.8063 16.9438L20.6 16.15C20.7699 15.982 20.9845 15.8662 21.2182 15.8163C21.4519 15.7665 21.6951 15.7847 21.9188 15.8688C22.4858 16.0803 23.075 16.2271 23.675 16.3063C23.9786 16.3491 24.2559 16.502 24.4541 16.7359C24.6523 16.9699 24.7576 17.2685 24.75 17.575Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_225_1675">
              <rect
                width="32"
                height="32"
                fill="white"
                transform="translate(10 14)"
              />
            </clipPath>
            <clipPath id="clip1_225_1675">
              <rect
                width="15"
                height="15"
                fill="white"
                transform="translate(11 7)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
      {svg && svgType === 'outgoingStats' && (
        <svg
          className={styles.svg}
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="50" height="50" rx="11" fill="#155DFC" />
          <g clipPath="url(#clip0_422_3591)">
            <path
              d="M40.6667 22L28 34.6667L21.3333 28L11.3333 38M40.6667 22H32.6667M40.6667 22V30"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g clipPath="url(#clip1_422_3591)">
            <path
              d="M22.875 7.625L25.375 10.125M25.375 10.125L22.875 12.625M25.375 10.125L20.375 10.125M24.75 17.575V19.45C24.7507 19.6241 24.715 19.7964 24.6453 19.9558C24.5756 20.1153 24.4733 20.2585 24.345 20.3762C24.2168 20.4938 24.0654 20.5834 23.9005 20.6392C23.7356 20.695 23.5609 20.7157 23.3875 20.7C21.4643 20.491 19.6169 19.8338 17.9937 18.7812C16.4836 17.8217 15.2033 16.5414 14.2437 15.0312C13.1875 13.4008 12.5301 11.5444 12.325 9.6125C12.3094 9.43967 12.3299 9.26548 12.3853 9.10102C12.4407 8.93656 12.5297 8.78543 12.6467 8.65726C12.7637 8.5291 12.9061 8.42669 13.0649 8.35658C13.2236 8.28646 13.3952 8.25016 13.5687 8.25H15.4437C15.7471 8.24701 16.0411 8.35442 16.2711 8.55221C16.5011 8.74999 16.6513 9.02465 16.6937 9.325C16.7729 9.92504 16.9197 10.5142 17.1312 11.0813C17.2153 11.305 17.2335 11.5481 17.1837 11.7818C17.1338 12.0155 17.018 12.2301 16.85 12.4L16.0562 13.1937C16.946 14.7585 18.2415 16.054 19.8062 16.9438L20.6 16.15C20.7699 15.982 20.9845 15.8662 21.2182 15.8163C21.4519 15.7665 21.695 15.7847 21.9187 15.8688C22.4858 16.0803 23.075 16.2271 23.675 16.3063C23.9786 16.3491 24.2559 16.502 24.4541 16.7359C24.6523 16.9699 24.7576 17.2685 24.75 17.575Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_422_3591">
              <rect
                width="32"
                height="32"
                fill="white"
                transform="translate(10 14)"
              />
            </clipPath>
            <clipPath id="clip1_422_3591">
              <rect
                width="15"
                height="15"
                fill="white"
                transform="translate(11 7)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
      {svg && svgType === 'blacklist' && (
        <svg
          className={styles.svg}
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="50" height="50" rx="11" fill="#155DFC" />
          <g clipPath="url(#clip0_229_1123)">
            <path
              d="M23.2402 26.7468C24.5933 28.1012 26.1226 29.2672 27.7868 30.2135L29.4802 28.5202C29.8427 28.1617 30.3004 27.9146 30.799 27.8083C31.2976 27.7019 31.8163 27.7408 32.2935 27.9202C33.5032 28.3716 34.7601 28.6847 36.0402 28.8535C36.6809 28.9441 37.2668 29.2645 37.6888 29.7551C38.1107 30.2458 38.3399 30.8731 38.3335 31.5202V35.5202C38.335 35.8915 38.2589 36.2591 38.1102 36.5993C37.9614 36.9395 37.7432 37.2449 37.4696 37.496C37.196 37.747 36.8729 37.9381 36.5212 38.0571C36.1694 38.1761 35.7967 38.2203 35.4268 38.1868C31.3239 37.741 27.3828 36.339 23.9202 34.0935C22.3139 33.0736 20.8249 31.8797 19.4802 30.5335M15.9202 26.0802C13.6746 22.6175 12.2726 18.6764 11.8268 14.5735C11.7935 14.2048 11.8373 13.8332 11.9555 13.4823C12.0737 13.1315 12.2636 12.8091 12.5132 12.5357C12.7628 12.2622 13.0666 12.0438 13.4052 11.8942C13.7439 11.7446 14.11 11.6672 14.4802 11.6668H18.4802C19.1272 11.6605 19.7546 11.8896 20.2452 12.3115C20.7358 12.7335 21.0563 13.3194 21.1468 13.9602C21.3157 15.2403 21.6288 16.4971 22.0802 17.7068C22.2596 18.1841 22.2984 18.7027 22.192 19.2013C22.0857 19.7 21.8386 20.1576 21.4802 20.5202L19.7868 22.2135M39.6668 10.3335L10.3335 39.6668"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_229_1123">
              <rect
                width="32"
                height="32"
                fill="white"
                transform="translate(9 9)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
      {svg && svgType === 'dispensarization' && (
        <svg
          className={styles.svg}
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="50" height="50" rx="11" fill="#155DFC" />
          <path
            d="M38.3334 31.56V35.56C38.3349 35.9313 38.2589 36.2989 38.1101 36.6391C37.9613 36.9794 37.7431 37.2848 37.4695 37.5358C37.1959 37.7869 36.8728 37.978 36.5211 38.0969C36.1693 38.2159 35.7966 38.2601 35.4267 38.2267C31.3239 37.7809 27.3827 36.3789 23.9201 34.1333C20.6985 32.0862 17.9672 29.3549 15.9201 26.1333C13.6667 22.6549 12.2644 18.6947 11.8267 14.5733C11.7934 14.2046 11.8372 13.833 11.9554 13.4822C12.0736 13.1313 12.2635 12.8089 12.5131 12.5355C12.7627 12.2621 13.0665 12.0436 13.4051 11.894C13.7438 11.7444 14.1099 11.667 14.4801 11.6667H18.4801C19.1271 11.6603 19.7545 11.8894 20.2451 12.3114C20.7357 12.7333 21.0562 13.3193 21.1467 13.96C21.3156 15.2401 21.6287 16.497 22.0801 17.7067C22.2595 18.1839 22.2983 18.7026 22.1919 19.2012C22.0856 19.6998 21.8386 20.1575 21.4801 20.52L19.7867 22.2133C21.6848 25.5514 24.4487 28.3153 27.7867 30.2133L29.4801 28.52C29.8426 28.1615 30.3003 27.9145 30.7989 27.8081C31.2975 27.7018 31.8162 27.7406 32.2934 27.92C33.5031 28.3714 34.76 28.6845 36.0401 28.8533C36.6878 28.9447 37.2793 29.2709 37.7021 29.77C38.125 30.269 38.3496 30.9061 38.3334 31.56Z"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M36 8.25V10.75M31 8.25V10.75M27.875 13.25H39.125M29.125 9.5H37.875C38.5654 9.5 39.125 10.0596 39.125 10.75V19.5C39.125 20.1904 38.5654 20.75 37.875 20.75H29.125C28.4346 20.75 27.875 20.1904 27.875 19.5V10.75C27.875 10.0596 28.4346 9.5 29.125 9.5Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {svg && svgType === 'dispensarizationStats' && (
        <svg
          className={styles.svg}
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="50" height="50" rx="11" fill="#155DFC" />
          <g clipPath="url(#clip0_210_1609)">
            <path
              d="M40.6666 22L27.9999 34.6667L21.3333 28L11.3333 38M40.6666 22H32.6666M40.6666 22V30"
              stroke="white"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M21 8.25V10.75M16 8.25V10.75M12.875 13.25H24.125M14.125 9.5H22.875C23.5654 9.5 24.125 10.0596 24.125 10.75V19.5C24.125 20.1904 23.5654 20.75 22.875 20.75H14.125C13.4346 20.75 12.875 20.1904 12.875 19.5V10.75C12.875 10.0596 13.4346 9.5 14.125 9.5Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <defs>
            <clipPath id="clip0_210_1609">
              <rect
                width="32"
                height="32"
                fill="white"
                transform="translate(10 14)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
      {svg && svgType === 'survey' && (
        <svg
          className={styles.svg}
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="50" height="50" rx="11" fill="#155DFC" />
          <path
            d="M38.3339 31.56V35.56C38.3354 35.9314 38.2593 36.2989 38.1106 36.6392C37.9618 36.9794 37.7436 37.2848 37.47 37.5358C37.1964 37.7869 36.8733 37.978 36.5216 38.097C36.1698 38.2159 35.7971 38.2601 35.4272 38.2267C31.3243 37.7809 27.3832 36.3789 23.9206 34.1334C20.699 32.0862 17.9677 29.3549 15.9206 26.1334C13.6672 22.655 12.2649 18.6947 11.8272 14.5734C11.7939 14.2047 11.8377 13.833 11.9559 13.4822C12.0741 13.1313 12.264 12.8089 12.5136 12.5355C12.7632 12.2621 13.067 12.0436 13.4056 11.8941C13.7443 11.7445 14.1103 11.667 14.4806 11.6667H18.4806C19.1276 11.6603 19.755 11.8895 20.2456 12.3114C20.7362 12.7333 21.0567 13.3193 21.1472 13.96C21.3161 15.2401 21.6292 16.497 22.0806 17.7067C22.26 18.1839 22.2988 18.7026 22.1924 19.2012C22.0861 19.6998 21.839 20.1575 21.4806 20.52L19.7872 22.2134C21.6853 25.5514 24.4492 28.3153 27.7872 30.2134L29.4806 28.52C29.8431 28.1615 30.3008 27.9145 30.7994 27.8082C31.298 27.7018 31.8167 27.7406 32.2939 27.92C33.5036 28.3714 34.7605 28.6845 36.0406 28.8534C36.6883 28.9447 37.2798 29.271 37.7026 29.77C38.1254 30.2691 38.3501 30.9061 38.3339 31.56Z"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.75 8.25H29.75C29.4185 8.25 29.1005 8.3817 28.8661 8.61612C28.6317 8.85054 28.5 9.16848 28.5 9.5V19.5C28.5 19.8315 28.6317 20.1495 28.8661 20.3839C29.1005 20.6183 29.4185 20.75 29.75 20.75H37.25C37.5815 20.75 37.8995 20.6183 38.1339 20.3839C38.3683 20.1495 38.5 19.8315 38.5 19.5V12M34.75 8.25L38.5 12M34.75 8.25L34.75 12H38.5M36 15.125H31M36 17.625H31M32.25 12.625H31"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {svg && svgType === 'questionnaireTemplates' && (
        <svg
          className={styles.svg}
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="50" height="50" rx="11" fill="#155DFC" />
          <path
            d="M35.6673 19.6667L27.6673 11.6667H17.0007C16.2934 11.6667 15.6151 11.9476 15.115 12.4477C14.6149 12.9478 14.334 13.6261 14.334 14.3334V35.6667C14.334 36.3739 14.6149 37.0522 15.115 37.5523C15.6151 38.0524 16.2934 38.3334 17.0007 38.3334H33.0007C33.7079 38.3334 34.3862 38.0524 34.8863 37.5523C35.3864 37.0522 35.6673 36.3739 35.6673 35.6667V19.6667ZM27.6673 11.6667L27.6673 19.6667H35.6673M30.334 26.3334H19.6673M30.334 31.6667H19.6673M22.334 21H19.6673"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {svg && svgType === 'sipAccounts' && (
        <span className={styles.svg}>
          <SipAccountsIcon />
        </span>
      )}
      {svg && svgType === 'callPoolSettings' && (
        <svg
          className={styles.svg}
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="50" height="50" rx="11" fill="#155DFC" />
          <g clipPath="url(#clip0_1505_7670)">
            <path
              d="M37.5 18.375C38.5355 18.375 39.375 17.5355 39.375 16.5C39.375 15.4645 38.5355 14.625 37.5 14.625C36.4645 14.625 35.625 15.4645 35.625 16.5C35.625 17.5355 36.4645 18.375 37.5 18.375Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M42.125 18.375C42.0418 18.5635 42.017 18.7726 42.0537 18.9754C42.0905 19.1781 42.1872 19.3652 42.3312 19.5125L42.3687 19.55C42.485 19.6661 42.5772 19.804 42.6401 19.9557C42.703 20.1074 42.7354 20.2701 42.7354 20.4344C42.7354 20.5986 42.703 20.7613 42.6401 20.913C42.5772 21.0648 42.485 21.2027 42.3687 21.3187C42.2527 21.435 42.1148 21.5272 41.963 21.5901C41.8113 21.653 41.6486 21.6854 41.4844 21.6854C41.3201 21.6854 41.1574 21.653 41.0057 21.5901C40.854 21.5272 40.7161 21.435 40.6 21.3187L40.5625 21.2812C40.4152 21.1372 40.2281 21.0405 40.0254 21.0037C39.8226 20.967 39.6135 20.9918 39.425 21.075C39.2401 21.1542 39.0825 21.2858 38.9714 21.4535C38.8604 21.6211 38.8008 21.8176 38.8 22.0187V22.125C38.8 22.4565 38.6683 22.7745 38.4339 23.0089C38.1995 23.2433 37.8815 23.375 37.55 23.375C37.2185 23.375 36.9005 23.2433 36.6661 23.0089C36.4317 22.7745 36.3 22.4565 36.3 22.125V22.0687C36.2952 21.8619 36.2282 21.6612 36.1078 21.4929C35.9874 21.3246 35.8192 21.1964 35.625 21.125C35.4365 21.0418 35.2274 21.017 35.0246 21.0537C34.8219 21.0905 34.6348 21.1872 34.4875 21.3312L34.45 21.3687C34.3339 21.485 34.196 21.5772 34.0443 21.6401C33.8926 21.703 33.7299 21.7354 33.5656 21.7354C33.4014 21.7354 33.2387 21.703 33.0869 21.6401C32.9352 21.5772 32.7973 21.485 32.6812 21.3687C32.565 21.2527 32.4728 21.1148 32.4099 20.963C32.347 20.8113 32.3146 20.6486 32.3146 20.4844C32.3146 20.3201 32.347 20.1574 32.4099 20.0057C32.4728 19.854 32.565 19.7161 32.6812 19.6L32.7187 19.5625C32.8628 19.4152 32.9595 19.2281 32.9963 19.0254C33.033 18.8226 33.0082 18.6135 32.925 18.425C32.8458 18.2401 32.7142 18.0825 32.5465 17.9714C32.3789 17.8604 32.1824 17.8008 31.9812 17.8H31.875C31.5435 17.8 31.2255 17.6683 30.9911 17.4339C30.7567 17.1995 30.625 16.8815 30.625 16.55C30.625 16.2185 30.7567 15.9005 30.9911 15.6661C31.2255 15.4317 31.5435 15.3 31.875 15.3H31.9312C32.1381 15.2952 32.3388 15.2282 32.5071 15.1078C32.6754 14.9874 32.8036 14.8192 32.875 14.625C32.9582 14.4365 32.983 14.2274 32.9463 14.0246C32.9095 13.8219 32.8128 13.6348 32.6687 13.4875L32.6312 13.45C32.515 13.3339 32.4228 13.196 32.3599 13.0443C32.297 12.8926 32.2646 12.7299 32.2646 12.5656C32.2646 12.4014 32.297 12.2387 32.3599 12.0869C32.4228 11.9352 32.515 11.7973 32.6312 11.6812C32.7473 11.565 32.8852 11.4728 33.0369 11.4099C33.1887 11.347 33.3514 11.3146 33.5156 11.3146C33.6799 11.3146 33.8426 11.347 33.9943 11.4099C34.146 11.4728 34.2839 11.565 34.4 11.6812L34.4375 11.7187C34.5848 11.8628 34.7719 11.9595 34.9746 11.9963C35.1774 12.033 35.3865 12.0082 35.575 11.925H35.625C35.8099 11.8458 35.9675 11.7142 36.0786 11.5465C36.1896 11.3789 36.2492 11.1824 36.25 10.9812V10.875C36.25 10.5435 36.3817 10.2255 36.6161 9.99112C36.8505 9.7567 37.1685 9.625 37.5 9.625C37.8315 9.625 38.1495 9.7567 38.3839 9.99112C38.6183 10.2255 38.75 10.5435 38.75 10.875V10.9312C38.7508 11.1324 38.8104 11.3289 38.9214 11.4965C39.0325 11.6642 39.1901 11.7958 39.375 11.875C39.5635 11.9582 39.7726 11.983 39.9754 11.9463C40.1781 11.9095 40.3652 11.8128 40.5125 11.6687L40.55 11.6312C40.6661 11.515 40.804 11.4228 40.9557 11.3599C41.1074 11.297 41.2701 11.2646 41.4344 11.2646C41.5986 11.2646 41.7613 11.297 41.913 11.3599C42.0648 11.4228 42.2027 11.515 42.3187 11.6312C42.435 11.7473 42.5272 11.8852 42.5901 12.0369C42.653 12.1887 42.6854 12.3514 42.6854 12.5156C42.6854 12.6799 42.653 12.8426 42.5901 12.9943C42.5272 13.146 42.435 13.2839 42.3187 13.4L42.2812 13.4375C42.1372 13.5848 42.0405 13.7719 42.0037 13.9746C41.967 14.1774 41.9918 14.3865 42.075 14.575V14.625C42.1542 14.8099 42.2858 14.9675 42.4535 15.0786C42.6211 15.1896 42.8176 15.2492 43.0187 15.25H43.125C43.4565 15.25 43.7745 15.3817 44.0089 15.6161C44.2433 15.8505 44.375 16.1685 44.375 16.5C44.375 16.8315 44.2433 17.1495 44.0089 17.3839C43.7745 17.6183 43.4565 17.75 43.125 17.75H43.0687C42.8676 17.7508 42.6711 17.8104 42.5035 17.9214C42.3358 18.0325 42.2042 18.1901 42.125 18.375Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M34.3339 31.56V35.56C34.3354 35.9313 34.2593 36.2989 34.1106 36.6391C33.9618 36.9793 33.7436 37.2848 33.47 37.5358C33.1964 37.7868 32.8733 37.9779 32.5216 38.0969C32.1698 38.2159 31.7971 38.2601 31.4272 38.2266C27.3243 37.7808 23.3832 36.3788 19.9206 34.1333C16.699 32.0862 13.9677 29.3549 11.9206 26.1333C9.6672 22.6549 8.26489 18.6946 7.82723 14.5733C7.79391 14.2046 7.83773 13.833 7.9559 13.4821C8.07406 13.1313 8.26399 12.8089 8.51358 12.5355C8.76318 12.262 9.06697 12.0436 9.40562 11.894C9.74426 11.7444 10.1103 11.667 10.4806 11.6666H14.4806C15.1276 11.6603 15.755 11.8894 16.2456 12.3113C16.7362 12.7333 17.0567 13.3192 17.1472 13.96C17.3161 15.2401 17.6292 16.4969 18.0806 17.7066C18.26 18.1839 18.2988 18.7025 18.1924 19.2011C18.0861 19.6998 17.839 20.1574 17.4806 20.52L15.7872 22.2133C17.6853 25.5514 20.4492 28.3152 23.7872 30.2133L25.4806 28.52C25.8431 28.1615 26.3008 27.9144 26.7994 27.8081C27.298 27.7018 27.8167 27.7406 28.2939 27.92C29.5036 28.3714 30.7605 28.6845 32.0406 28.8533C32.6883 28.9447 33.2798 29.2709 33.7026 29.77C34.1254 30.269 34.3501 30.9061 34.3339 31.56Z"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <defs>
            <clipPath id="clip0_1505_7670">
              <rect
                width="15"
                height="15"
                fill="white"
                transform="translate(30 9)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
      {svg && svgType === 'settingsCalls' && (
        <svg
          className={styles.svg}
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="50" height="50" rx="11" fill="#155DFC" />
          <g clipPath="url(#clip0_326_2584)">
            <path
              d="M37.5 18.375C38.5355 18.375 39.375 17.5355 39.375 16.5C39.375 15.4645 38.5355 14.625 37.5 14.625C36.4645 14.625 35.625 15.4645 35.625 16.5C35.625 17.5355 36.4645 18.375 37.5 18.375Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M42.125 18.375C42.0418 18.5635 42.017 18.7726 42.0537 18.9754C42.0905 19.1781 42.1872 19.3652 42.3312 19.5125L42.3687 19.55C42.485 19.6661 42.5772 19.804 42.6401 19.9557C42.703 20.1074 42.7354 20.2701 42.7354 20.4344C42.7354 20.5986 42.703 20.7613 42.6401 20.913C42.5772 21.0648 42.485 21.2027 42.3687 21.3187C42.2527 21.435 42.1148 21.5272 41.963 21.5901C41.8113 21.653 41.6486 21.6854 41.4844 21.6854C41.3201 21.6854 41.1574 21.653 41.0057 21.5901C40.854 21.5272 40.7161 21.435 40.6 21.3187L40.5625 21.2812C40.4152 21.1372 40.2281 21.0405 40.0254 21.0037C39.8226 20.967 39.6135 20.9918 39.425 21.075C39.2401 21.1542 39.0825 21.2858 38.9714 21.4535C38.8604 21.6211 38.8008 21.8176 38.8 22.0187V22.125C38.8 22.4565 38.6683 22.7745 38.4339 23.0089C38.1995 23.2433 37.8815 23.375 37.55 23.375C37.2185 23.375 36.9005 23.2433 36.6661 23.0089C36.4317 22.7745 36.3 22.4565 36.3 22.125V22.0687C36.2952 21.8619 36.2282 21.6612 36.1078 21.4929C35.9874 21.3246 35.8192 21.1964 35.625 21.125C35.4365 21.0418 35.2274 21.017 35.0246 21.0537C34.8219 21.0905 34.6348 21.1872 34.4875 21.3312L34.45 21.3687C34.3339 21.485 34.196 21.5772 34.0443 21.6401C33.8926 21.703 33.7299 21.7354 33.5656 21.7354C33.4014 21.7354 33.2387 21.703 33.0869 21.6401C32.9352 21.5772 32.7973 21.485 32.6812 21.3687C32.565 21.2527 32.4728 21.1148 32.4099 20.963C32.347 20.8113 32.3146 20.6486 32.3146 20.4844C32.3146 20.3201 32.347 20.1574 32.4099 20.0057C32.4728 19.854 32.565 19.7161 32.6812 19.6L32.7187 19.5625C32.8628 19.4152 32.9595 19.2281 32.9963 19.0254C33.033 18.8226 33.0082 18.6135 32.925 18.425C32.8458 18.2401 32.7142 18.0825 32.5465 17.9714C32.3789 17.8604 32.1824 17.8008 31.9812 17.8H31.875C31.5435 17.8 31.2255 17.6683 30.9911 17.4339C30.7567 17.1995 30.625 16.8815 30.625 16.55C30.625 16.2185 30.7567 15.9005 30.9911 15.6661C31.2255 15.4317 31.5435 15.3 31.875 15.3H31.9312C32.1381 15.2952 32.3388 15.2282 32.5071 15.1078C32.6754 14.9874 32.8036 14.8192 32.875 14.625C32.9582 14.4365 32.983 14.2274 32.9463 14.0246C32.9095 13.8219 32.8128 13.6348 32.6687 13.4875L32.6312 13.45C32.515 13.3339 32.4228 13.196 32.3599 13.0443C32.297 12.8926 32.2646 12.7299 32.2646 12.5656C32.2646 12.4014 32.297 12.2387 32.3599 12.0869C32.4228 11.9352 32.515 11.7973 32.6312 11.6812C32.7473 11.565 32.8852 11.4728 33.0369 11.4099C33.1887 11.347 33.3514 11.3146 33.5156 11.3146C33.6799 11.3146 33.8426 11.347 33.9943 11.4099C34.146 11.4728 34.2839 11.565 34.4 11.6812L34.4375 11.7187C34.5848 11.8628 34.7719 11.9595 34.9746 11.9963C35.1774 12.033 35.3865 12.0082 35.575 11.925H35.625C35.8099 11.8458 35.9675 11.7142 36.0786 11.5465C36.1896 11.3789 36.2492 11.1824 36.25 10.9812V10.875C36.25 10.5435 36.3817 10.2255 36.6161 9.99112C36.8505 9.7567 37.1685 9.625 37.5 9.625C37.8315 9.625 38.1495 9.7567 38.3839 9.99112C38.6183 10.2255 38.75 10.5435 38.75 10.875V10.9312C38.7508 11.1324 38.8104 11.3289 38.9214 11.4965C39.0325 11.6642 39.1901 11.7958 39.375 11.875C39.5635 11.9582 39.7726 11.983 39.9754 11.9463C40.1781 11.9095 40.3652 11.8128 40.5125 11.6687L40.55 11.6312C40.6661 11.515 40.804 11.4228 40.9557 11.3599C41.1074 11.297 41.2701 11.2646 41.4344 11.2646C41.5986 11.2646 41.7613 11.297 41.913 11.3599C42.0648 11.4228 42.2027 11.515 42.3187 11.6312C42.435 11.7473 42.5272 11.8852 42.5901 12.0369C42.653 12.1887 42.6854 12.3514 42.6854 12.5156C42.6854 12.6799 42.653 12.8426 42.5901 12.9943C42.5272 13.146 42.435 13.2839 42.3187 13.4L42.2812 13.4375C42.1372 13.5848 42.0405 13.7719 42.0037 13.9746C41.967 14.1774 41.9918 14.3865 42.075 14.575V14.625C42.1542 14.8099 42.2858 14.9675 42.4535 15.0786C42.6211 15.1896 42.8176 15.2492 43.0187 15.25H43.125C43.4565 15.25 43.7745 15.3817 44.0089 15.6161C44.2433 15.8505 44.375 16.1685 44.375 16.5C44.375 16.8315 44.2433 17.1495 44.0089 17.3839C43.7745 17.6183 43.4565 17.75 43.125 17.75H43.0687C42.8676 17.7508 42.6711 17.8104 42.5035 17.9214C42.3358 18.0325 42.2042 18.1901 42.125 18.375Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M31.6663 37V34.3333C31.6663 32.9188 31.1044 31.5623 30.1042 30.5621C29.1041 29.5619 27.7475 29 26.333 29H15.6663C14.2519 29 12.8953 29.5619 11.8951 30.5621C10.8949 31.5623 10.333 32.9188 10.333 34.3333V37M26.333 18.3333C26.333 21.2789 23.9452 23.6667 20.9997 23.6667C18.0542 23.6667 15.6663 21.2789 15.6663 18.3333C15.6663 15.3878 18.0542 13 20.9997 13C23.9452 13 26.333 15.3878 26.333 18.3333Z"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <defs>
            <clipPath id="clip0_326_2584">
              <rect
                width="15"
                height="15"
                fill="white"
                transform="translate(30 9)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
      {svg && svgType === 'users' && (
        <svg
          className={styles.svg}
          width="50"
          height="50"
          viewBox="0 0 50 50"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="50" height="50" rx="11" fill="#155DFC" />
          <g clipPath="url(#clip0_326_2584)">
            <path
              d="M37.5 18.375C38.5355 18.375 39.375 17.5355 39.375 16.5C39.375 15.4645 38.5355 14.625 37.5 14.625C36.4645 14.625 35.625 15.4645 35.625 16.5C35.625 17.5355 36.4645 18.375 37.5 18.375Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M42.125 18.375C42.0418 18.5635 42.017 18.7726 42.0537 18.9754C42.0905 19.1781 42.1872 19.3652 42.3312 19.5125L42.3687 19.55C42.485 19.6661 42.5772 19.804 42.6401 19.9557C42.703 20.1074 42.7354 20.2701 42.7354 20.4344C42.7354 20.5986 42.703 20.7613 42.6401 20.913C42.5772 21.0648 42.485 21.2027 42.3687 21.3187C42.2527 21.435 42.1148 21.5272 41.963 21.5901C41.8113 21.653 41.6486 21.6854 41.4844 21.6854C41.3201 21.6854 41.1574 21.653 41.0057 21.5901C40.854 21.5272 40.7161 21.435 40.6 21.3187L40.5625 21.2812C40.4152 21.1372 40.2281 21.0405 40.0254 21.0037C39.8226 20.967 39.6135 20.9918 39.425 21.075C39.2401 21.1542 39.0825 21.2858 38.9714 21.4535C38.8604 21.6211 38.8008 21.8176 38.8 22.0187V22.125C38.8 22.4565 38.6683 22.7745 38.4339 23.0089C38.1995 23.2433 37.8815 23.375 37.55 23.375C37.2185 23.375 36.9005 23.2433 36.6661 23.0089C36.4317 22.7745 36.3 22.4565 36.3 22.125V22.0687C36.2952 21.8619 36.2282 21.6612 36.1078 21.4929C35.9874 21.3246 35.8192 21.1964 35.625 21.125C35.4365 21.0418 35.2274 21.017 35.0246 21.0537C34.8219 21.0905 34.6348 21.1872 34.4875 21.3312L34.45 21.3687C34.3339 21.485 34.196 21.5772 34.0443 21.6401C33.8926 21.703 33.7299 21.7354 33.5656 21.7354C33.4014 21.7354 33.2387 21.703 33.0869 21.6401C32.9352 21.5772 32.7973 21.485 32.6812 21.3687C32.565 21.2527 32.4728 21.1148 32.4099 20.963C32.347 20.8113 32.3146 20.6486 32.3146 20.4844C32.3146 20.3201 32.347 20.1574 32.4099 20.0057C32.4728 19.854 32.565 19.7161 32.6812 19.6L32.7187 19.5625C32.8628 19.4152 32.9595 19.2281 32.9963 19.0254C33.033 18.8226 33.0082 18.6135 32.925 18.425C32.8458 18.2401 32.7142 18.0825 32.5465 17.9714C32.3789 17.8604 32.1824 17.8008 31.9812 17.8H31.875C31.5435 17.8 31.2255 17.6683 30.9911 17.4339C30.7567 17.1995 30.625 16.8815 30.625 16.55C30.625 16.2185 30.7567 15.9005 30.9911 15.6661C31.2255 15.4317 31.5435 15.3 31.875 15.3H31.9312C32.1381 15.2952 32.3388 15.2282 32.5071 15.1078C32.6754 14.9874 32.8036 14.8192 32.875 14.625C32.9582 14.4365 32.983 14.2274 32.9463 14.0246C32.9095 13.8219 32.8128 13.6348 32.6687 13.4875L32.6312 13.45C32.515 13.3339 32.4228 13.196 32.3599 13.0443C32.297 12.8926 32.2646 12.7299 32.2646 12.5656C32.2646 12.4014 32.297 12.2387 32.3599 12.0869C32.4228 11.9352 32.515 11.7973 32.6312 11.6812C32.7473 11.565 32.8852 11.4728 33.0369 11.4099C33.1887 11.347 33.3514 11.3146 33.5156 11.3146C33.6799 11.3146 33.8426 11.347 33.9943 11.4099C34.146 11.4728 34.2839 11.565 34.4 11.6812L34.4375 11.7187C34.5848 11.8628 34.7719 11.9595 34.9746 11.9963C35.1774 12.033 35.3865 12.0082 35.575 11.925H35.625C35.8099 11.8458 35.9675 11.7142 36.0786 11.5465C36.1896 11.3789 36.2492 11.1824 36.25 10.9812V10.875C36.25 10.5435 36.3817 10.2255 36.6161 9.99112C36.8505 9.7567 37.1685 9.625 37.5 9.625C37.8315 9.625 38.1495 9.7567 38.3839 9.99112C38.6183 10.2255 38.75 10.5435 38.75 10.875V10.9312C38.7508 11.1324 38.8104 11.3289 38.9214 11.4965C39.0325 11.6642 39.1901 11.7958 39.375 11.875C39.5635 11.9582 39.7726 11.983 39.9754 11.9463C40.1781 11.9095 40.3652 11.8128 40.5125 11.6687L40.55 11.6312C40.6661 11.515 40.804 11.4228 40.9557 11.3599C41.1074 11.297 41.2701 11.2646 41.4344 11.2646C41.5986 11.2646 41.7613 11.297 41.913 11.3599C42.0648 11.4228 42.2027 11.515 42.3187 11.6312C42.435 11.7473 42.5272 11.8852 42.5901 12.0369C42.653 12.1887 42.6854 12.3514 42.6854 12.5156C42.6854 12.6799 42.653 12.8426 42.5901 12.9943C42.5272 13.146 42.435 13.2839 42.3187 13.4L42.2812 13.4375C42.1372 13.5848 42.0405 13.7719 42.0037 13.9746C41.967 14.1774 41.9918 14.3865 42.075 14.575V14.625C42.1542 14.8099 42.2858 14.9675 42.4535 15.0786C42.6211 15.1896 42.8176 15.2492 43.0187 15.25H43.125C43.4565 15.25 43.7745 15.3817 44.0089 15.6161C44.2433 15.8505 44.375 16.1685 44.375 16.5C44.375 16.8315 44.2433 17.1495 44.0089 17.3839C43.7745 17.6183 43.4565 17.75 43.125 17.75H43.0687C42.8676 17.7508 42.6711 17.8104 42.5035 17.9214C42.3358 18.0325 42.2042 18.1901 42.125 18.375Z"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M31.6663 37V34.3333C31.6663 32.9188 31.1044 31.5623 30.1042 30.5621C29.1041 29.5619 27.7475 29 26.333 29H15.6663C14.2519 29 12.8953 29.5619 11.8951 30.5621C10.8949 31.5623 10.333 32.9188 10.333 34.3333V37M26.333 18.3333C26.333 21.2789 23.9452 23.6667 20.9997 23.6667C18.0542 23.6667 15.6663 21.2789 15.6663 18.3333C15.6663 15.3878 18.0542 13 20.9997 13C23.9452 13 26.333 15.3878 26.333 18.3333Z"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <defs>
            <clipPath id="clip0_326_2584">
              <rect
                width="15"
                height="15"
                fill="white"
                transform="translate(30 9)"
              />
            </clipPath>
          </defs>
        </svg>
      )}
      <div className={styles.blockMenu}>
        <Title className={styles.blockTitle} level={3}>
          {title}
        </Title>
        <Typography.Text type="secondary" className={styles.blockSubtitle}>
          {subtitle}
        </Typography.Text>
      </div>
    </div>
  );
};

export default memo(SiteMenu);
